// extracted by mini-css-extract-plugin
export var dividerLine = "_8q-3";
export var itemImage = "_8q-9";
export var lightDivider = "_8q-4";
export var modalContent = "_8q-5";
export var modalContentCompact = "_8q-6";
export var productCard = "_8q-a";
export var productImage = "_8q-b";
export var productImageCompact = "_8q-7";
export var productImagePlaceholder = "_8q-c";
export var productImagePlaceholderCompact = "_8q-8";
export var progressBarBackground = "_8q-1";
export var progressBarContainer = "_8q-0";
export var progressBarFill = "_8q-2";